import { Helper } from '@/services/helper';

const baseUrl: string = process.env.VUE_APP_BASE_URL;
const helper = new Helper();

export default {};
